import apiWrapper from 'Helpers/apiWrapper'

const endpoints = ((baseURL) => {
  return {
    smsMessageByIdMessage: (idMessage) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}`,
  }
})(process.env.BESMSMESSAGE_URL)

export const beMessGetSmsMessageByIdMessage = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.smsMessageByIdMessage(idMessage),
  }).then(({ data }) => data)
}
